import React, { useContext, useMemo } from 'react';
import { useInterpret } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';
import {
  createSubscriptionsMachine,
  modals,
  paymentGateway,
  productCatalog,
} from '../machines';
import { GlobalStateContext } from '../contexts';

type Props = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
};

export const GlobalStateProvider = ({ children }: Props) => {
  const { dataAccess } = useContext(DataAccessContext);
  const subscriptionsMachine = useMemo(
    () => createSubscriptionsMachine(dataAccess),
    []
  );

  const modalsService = useInterpret(modals);

  const subscriptionsService = useInterpret(subscriptionsMachine, {
    services: {
      getSubscriptions: () => dataAccess.getSubscriptions(),
    },
  });

  const productCatalogService = useInterpret(productCatalog, {
    services: {
      getProductsCatalog: () => dataAccess.getProductsCatalog(),
    },
  });

  const paymentGatewayService = useInterpret(paymentGateway, {
    services: {
      getGatewayConfig: () => dataAccess.getGatewayConfig(),
    },
  });

  return (
    <GlobalStateContext.Provider
      value={{
        modalsService,
        subscriptionsService,
        productCatalogService,
        paymentGatewayService,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};
